import React from 'react';

function Inventory() {
  const path = 'oldPages/inventory/InfoTRAC_inventory.html';

  return <iframe title="inventory" src={path} frameBorder="0" width="100%" height="350px" />;
}

export default Inventory;
